export const ACTIVE_WARNING = 'No active socket connection';
